import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Funciona si no soy buena con la tecnología?',
  answer: 'Totalmente. Si sabes enviar un mensaje de texto, puedes usar este sistema.'
}, {
  question: '¿Sirve para cualquier industria?',
  answer: 'Está optimizado para servicios de alto valor como seguros, salud y autos, pero el principio psicológico funciona para todo.'
}, {
  question: '¿Es muy largo de leer?',
  answer: 'No. Es una guía táctica diseñada para gente ocupada. Menos teoría, más acción.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-cream-50" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-29">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 mb-4" data-id="element-30">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-31" />
        </motion.div>

        <div className="space-y-4" data-id="element-32">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-xl shadow-sm border border-cream-100 overflow-hidden" data-id="element-33">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-34">
                <span className="text-lg font-bold text-navy-900 font-sans" data-id="element-35">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold-600 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-36" />
              </button>
              <AnimatePresence data-id="element-37">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-38">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-39">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}